import React from 'react';
import { Link } from 'react-scroll'
import LandingVideo from '../../Resources/Files/Landing-Video.mp4';
import LandingImage from '../LandingPage/LandingImage';
import LandingText from '../LandingPage/LandingText';
import '../../CSS/LandingPage.css';

function LandingPage() {
    return (
        <div className="Landing-frame"> 
            <div className="Video-frame">
                <p>WILL LIAO 2020 <br></br> HUA'LIEN, TAIWAN <br></br> SHOT BY DRONE </p>
                <video className="Video" autoPlay loop muted>
                    <source src={LandingVideo} type='video/mp4' />
                </video>
            </div>

            <div className="Content">
                <div className="Left">
                    <LandingImage />
                </div>
                <div className="Right">
                    <h1 className="Header">WILL LIAO</h1>
                    <LandingText />
                    <Link 
                        className="Button"
                        to="PortfolioPage"
                        spy={true}
                        smooth={true}
                        offset={-40}>
                            TO PORTFOLIO &darr;
                    </Link>
                </div>
            </div>
        </div>
    )
};

export default LandingPage;